import { useReactiveVar } from '@apollo/client';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import React from 'react';
import { getDensityConfig } from 'src/helpers/densityConfig';
import widthToBreakPoint from 'src/helpers/widthToBreakpoint';
import { akomiMediaCardGridVar } from 'src/store/akomiMediaCardGridVar';
import { AkomiMediaCardRouter } from '../AkomiMediaCardRouter';
import type { GridViewProps } from '../types';

type BreakPointKey = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const TwoUpView: React.FC<GridViewProps> = ({ assetsData, mediaCardBreakPoints, windowWidth }) => {
  const { density } = useReactiveVar(akomiMediaCardGridVar);
  const densityConfig = getDensityConfig(density);
  const breakpointKey = widthToBreakPoint(windowWidth) as BreakPointKey;
  const breakpointValue = mediaCardBreakPoints[breakpointKey];
  const columnsPerRow = typeof breakpointValue === 'number' ? 12 / breakpointValue : 12;

  return (
    <Grid container={true} wrap="wrap" direction="row" alignItems="flex-start">
      {assetsData.map((item, index) => {
        if ((index + 1) % columnsPerRow === 0 || index === assetsData.length - 1)
          return (
            <React.Fragment key={item.id}>
              <Grid item {...mediaCardBreakPoints}>
                <Box display="flex" alignItems="flex-start" justifyContent="center" margin={densityConfig.cardMargin}>
                  <AkomiMediaCardRouter item={item} key={item.id} index={index} />
                </Box>
              </Grid>
            </React.Fragment>
          );
        else
          return (
            <Grid key={item.id} item {...mediaCardBreakPoints}>
              <Box display="flex" alignItems="flex-start" justifyContent="center" margin={densityConfig.cardMargin}>
                <AkomiMediaCardRouter item={item} key={item.id} index={index} />
              </Box>
            </Grid>
          );
      })}
    </Grid>
  );
};

export default TwoUpView;
